angular.module('iconoglobe')
.service('happenings', ['$http', "$q", function($http, $q){
  this.getCountryHappenings = function(name, state){
      
    var canceler = $q.defer();
     
    var deferred = $q.defer();
      
    if(state.indexOf('world') > -1){
      $http.post('data/getEstaEventImage', {'countryName':name}, { 'timeout': deferred.promise, 'cancel': deferred}).then(function(res){
        deferred.resolve(res.data);
      },function(err){
        deferred.reject();
      });
    } else {
      $http.post('data/getEstaEventImage', {'stateCode':name}, { 'timeout': deferred.promise, 'cancel': deferred}).then(function(res){
        deferred.resolve(res.data);
      },function(err){
        deferred.reject();
      });
    }
    return deferred.promise;
  }
}])